export interface GetFilterQueryString<T> {
  filter: T
  style?: 'brackets' | 'dots'
}

export const getFilterQueryString = <
  T extends Record<string, string | number | boolean | null | undefined | (string | number)[]>,
>({
  filter,
  style = 'brackets',
}: GetFilterQueryString<T>) =>
  filter
    ? Object.entries(filter).reduce((res, [key, value]) => {
        if (Array.isArray(value)) {
          return `${res}${value.reduce(
            (acc, val) =>
              style === 'brackets'
                ? `${acc}&filter[${key}][]=${encodeURIComponent(val)}`
                : `${acc}&filter.${key}=${encodeURIComponent(val)}`,
            '',
          )}`
        } else {
          return `${res}${
            value
              ? style === 'brackets'
                ? `&filter[${key}]=${encodeURIComponent(value)}`
                : `&filter.${key}=${encodeURIComponent(value)}`
              : ''
          }`
        }
      }, '')
    : ''
